import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
//import "../styles/App.css"
import "../styles/Canteen.css"

const Canteen = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [, removeCookie] = useCookies([]);
  const [username, setUsername] = useState("");

  useEffect(() => {
    // The auth cookie is httpOnly, so it can't be read from JS here - the
    // server round-trip below is the only source of truth for the session.
    const verifyCookie = async () => {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/canteen`,
        {},
        { withCredentials: true }
      );
      const { success, user } = data;
      setUsername(user);
      return success
        ? (toast(`Welcome ${user} to Canteen!`, {
            position: "top-right",
          }))
        : (removeCookie("token"), navigate("/login"));
    };
    verifyCookie();
  }, [navigate, removeCookie]);
  const Logout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error('Error logging out:', error);
    }
    removeCookie("token");
    navigate("/login");
  };
  return (
    <>
      <div className="canteen_page">
        <h4>
          Welcome <span>{username}</span>
        </h4>
        <button onClick={Logout}>LOGOUT</button>
      </div>
      <div className="canteen_page_settings">
      Canteen page!
      </div>
      
      <ToastContainer />
    </>
  );
};

export default Canteen;
